import React, { FC, memo, useCallback } from 'react';

import { SortableContext } from '@dnd-kit/sortable';
import cn from 'classnames';
import { useNavigate } from 'react-router-dom';

import { IShortcut } from 'schemas';

import { ApplicationCard } from '../../ApplicationCard';
import { SortableCardItem } from '../../SortableCardItem';
import GroupWrapper from './components/GroupWrapper';
import s from './Group.module.scss';
import { GroupPros } from './interfaces';

const Group: FC<GroupPros> = memo(
  ({
    items,
    disabled,
    selectedApp,
    setSelectedApp,
    onContextMenu,
    size,
    placeholder,
    title,
    isOpen,
    setIsOpen,
    id,
  }) => {
    const navigate = useNavigate();

    const onClickHandled = useCallback(
      (item: IShortcut) => () => {
        if (selectedApp?.id === item.id) {
          setSelectedApp(null);
          return;
        }

        setSelectedApp(item);
      },
      [selectedApp, setSelectedApp]
    );

    return (
      <SortableContext items={items.map(({ id }) => id)} disabled={disabled}>
        <GroupWrapper
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          title={title}
          count={items.length}
          id={id}
        >
          <div className={cn(s.container, size && s[size])}>
            {items.length === 0 && (
              <div className={s.placeholder}>
                <span>{placeholder}</span>
              </div>
            )}
            {items.map((item) => (
              <SortableCardItem key={item.id} id={item.id} size={size}>
                <ApplicationCard
                  onContextMenu={onContextMenu(item)}
                  key={`application-${item.id}`}
                  title={item.title}
                  isActive={item.id === selectedApp?.id}
                  size={size}
                  imagePath={item.main_picture}
                  age={item.only_for_registered ? item.age_rating : null}
                  onClick={onClickHandled(item)}
                  onDoubleClick={() =>
                    navigate(`/applications/manage?id=${item.id}`)
                  }
                />
              </SortableCardItem>
            ))}
          </div>
        </GroupWrapper>
      </SortableContext>
    );
  }
);

export default Group;
